const UI_CONSTANTS = {
  TWITTER_WIDGET: "twitter",
  FACEBOOK_WIDGET: "facebook",
  FOLLOW_US: "followus",
  TERMS_AND_CONDITIONS: "t&c",
  FORGOT_PW_URL_HASH: "#forgotpassword",
  RESET_PW_URL_HASH: "#resetpassword",
  INVALID_URL_HASH: "#invalid",
  ACCOUNT_LOCKOUT: "#lockout",
  WARNING_LOCKOUT: "#warningLockout",
  MULTIPLE_ACCOUNT: "#multipleaccount",
  FORGOT_PW_EMAIL_URL_HASH: "#fpemailinfo",
  RESET_PW_MSG_URL_HASH: "#resetPwdInfo",
  RESET_MAIL_TEMPLATE_ID: "resetMail"
};

export default UI_CONSTANTS;
